$(document).ready(function () {

    clickSolution();

    function clickSolution() {


        if (window.innerWidth > 640) {
            var itemSolution = $('.item-solution-js');
            var itemSolutionText = $('.item-solution-text');
            if (!itemSolution.hasClass('active')) {
                itemSolution.first().addClass('active');
                var data = itemSolution.first().attr('data-solution');
                $('[data-solution-text="' + data + '"]').addClass('active');
            }

            itemSolution.on('click', function () {
                itemSolution.removeClass('active');
                itemSolutionText.removeClass('active');
                $(this).addClass('active');
                var data = $(this).attr('data-solution');
                $('[data-solution-text="' + data + '"]').addClass('active');
            })
        } else {
            var firstSolution = $('.item-solution').first();
            var firstText = $('.item-solution-text').first();

            firstSolution.addClass('active');
            firstText.insertAfter(firstSolution).slideDown();

            $('.item-solution').on('click', function (event) {
                event.preventDefault();
                if ($(this).hasClass('active')) {
                    return;
                }
                $('.item-solution').removeClass('active');
                $('.item-solution-text').slideUp();

                $(this).addClass('active');
                var solutionIndex = $(this).data('solution');
                var $correspondingText = $('.item-solution-text[data-solution-text="' + solutionIndex + '"]');
                $correspondingText.insertAfter($(this)).slideDown();
            });
        }


    }

    sliderCaseStudy();

	function sliderCaseStudy() {
        var onSwiperReady = window.mobidevOnSwiperReady || function (cb) {
            if (typeof Swiper !== 'undefined') {
                cb();
            }
        };
        onSwiperReady(function () {
            document.querySelectorAll('.case-studies__slider-js').forEach((sliderEl, index) => {
                const paginationEl = sliderEl.querySelector('.case-studies__slider-pagination');
                const nextBtn = sliderEl.querySelector('.case-studies__slider-next');
                const prevBtn = sliderEl.querySelector('.case-studies__slider-prev');

                new Swiper(sliderEl, {
                    slidesPerView: 1,
                    speed: 1000,
                    spaceBetween: 24,
                    loop: true,

                    pagination: paginationEl ?
                        {
                            el: paginationEl,
                            clickable: true,
                        } :
                        false,

                    navigation: nextBtn && prevBtn ?
                        {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        } :
                        false,

                    breakpoints: {
                        640: {
                            spaceBetween: 50,
                        },
                        1200: {
                            spaceBetween: 34,
                        },
                    },
                });
            });
        });
        // $slider.on('afterChange', function(event, slick) {
        //     changeHeightCaseStudy();
        // });
    }

    changeTextClient();

    function changeTextClient() {
        var clients = $('.case-study__client');

        clients.each(function () {
            var client = $(this);
            var arrow = client.find('.case-study__client-text-arrow, .case-study__client-text');

            arrow.on('click', function () {
                client.toggleClass('active');
            });
        });
    }

    // changeHeightCaseStudy()
    // function changeHeightCaseStudy() {
    //     if (window.innerWidth > 991) {
    //         var slickTrack = $('.case-studies .slick-track');
    //         var currentSlideHeight = $('.slick-active .case-study__container').height() + 120;
    //
    //         slickTrack.animate(
    //             { height: currentSlideHeight },
    //             {
    //                 duration: 200,
    //                 easing: 'swing',
    //             }
    //         );
    //     }
    //
    // }
    changeHeightCaseStudy()

    function changeHeightCaseStudy() {
        if (window.innerWidth > 991) {
            var slickTrack = $('.case-studies .slick-track');
            var currentSlideHeight = $('.slick-active .case-study__container').height() + 120;

            slickTrack.animate({
                height: currentSlideHeight
            }, {
                duration: 200,
                easing: 'swing',
            });
        }
        const $zoomWrapper = $('#wrapper');
        const $pageBuilder = $('#wrapper .page-builder');
        const $block = $('.clutch-widget, .carousel.slide, .js-slider-team-block, .stepper-container, .python-page-list');
        let lastZoomScale = null;

        function adjustZoom() {
            const viewportWidth = window.innerWidth;
            if ($pageBuilder[0]) {
                const nextScale = (viewportWidth > 1200 && viewportWidth < 1920)
                    ? (viewportWidth / 1920)
                    : 1;
                if (nextScale === lastZoomScale) {
                    return;
                }
                lastZoomScale = nextScale;
                if (nextScale !== 1) {
                    $zoomWrapper.css('zoom', nextScale);
                } else {
                    $zoomWrapper.css('zoom', 1);
                }
            } else {
                const nextScale = (viewportWidth > 992 && viewportWidth < 1920)
                    ? (viewportWidth / 1920)
                    : 1;
                if (nextScale === lastZoomScale) {
                    return;
                }
                lastZoomScale = nextScale;
                if (nextScale !== 1) {
                    $zoomWrapper.css('zoom', nextScale);

                    if ($block.length) {
                        $block.css('zoom', 1 / nextScale);
                        $block.css('transform-origin', '0 0');
                    }
                } else {
                    $zoomWrapper.css('zoom', 1);

                    if ($block.length) {
                        $block.css('zoom', 1);
                    }
                }
            }

        }

        adjustZoom();
        window.addEventListener("load", adjustZoom);
        window.addEventListener("resize", window.mobidevRafThrottle(adjustZoom));
    }
})
